import { ConfirmationModal, Input, Label, ValidationMessage } from '@modusign/design-system';
import { ChangeEvent, useCallback, useState } from 'react';

interface NewDraftSaveConfirmationModalProps {
  initialTitle: string;
  isOpen: boolean;
  onCancel: () => void;
  onConfirm: (title: string) => void;
}

export default function NewDraftSaveConfirmationModal({
  initialTitle,
  isOpen,
  onCancel,
  onConfirm,
}: NewDraftSaveConfirmationModalProps) {
  const [title, setTitle] = useState(initialTitle);
  const [error, setError] = useState('');

  const handleTitleChange = useCallback((event: ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    setTitle(value);
    if (!value) {
      setError('서식 이름을 입력해 주세요.');
    } else if (value.length < 2 || value.length > 50) {
      setError('서식 이름을 2자 이상 50자 이하로 입력해 주세요.');
    } else {
      setError('');
    }
  }, []);

  const handleConfirm = useCallback(() => {
    onConfirm(title);
  }, [onConfirm, title]);

  return (
    <ConfirmationModal
      confirmButtonLabel="새 서식으로 저장하기"
      isOpen={isOpen}
      maxWidth="xs"
      title="서식 저장하기"
      onClose={onCancel}
      onConfirm={handleConfirm}
    >
      <Label htmlFor="newDraftTitle">서식 이름</Label>
      <Input
        id="newDraftTitle"
        isInvalid={Boolean(error)}
        placeholder="서식 이름을 입력해 주세요."
        value={title}
        onChange={handleTitleChange}
      />
      {error && <ValidationMessage>{error}</ValidationMessage>}
    </ConfirmationModal>
  );
}
